var map = {
	"./10bis-T-RGB-H.png": 19695,
	"./400_500_visual.svg": 67831,
	"./EmptyShoppingCartStat.svg": 25795,
	"./Header_Duddles.png": 69226,
	"./Header_Duddles_old.png": 40411,
	"./Logo.svg": 14245,
	"./ResponseModalImage.jpg": 15343,
	"./Vector.png": 44557,
	"./a11yMenuIcon.svg": 166,
	"./accessibility-cover-desktop.jpg": 70611,
	"./accessibility-cover-mobile.jpg": 84061,
	"./address-finder-illustration.png": 85182,
	"./ageRestrictionModalImg.svg": 34421,
	"./asap_and_pooled/asap.svg": 63551,
	"./asap_and_pooled/asap.webp": 67040,
	"./asap_and_pooled/pickup-je.svg": 47394,
	"./asap_and_pooled/pickup-je.webp": 90105,
	"./asap_and_pooled/pickup.svg": 55904,
	"./asap_and_pooled/pickup.webp": 55229,
	"./asap_and_pooled/pooled.svg": 89633,
	"./asap_and_pooled/pooled.webp": 4866,
	"./carouselInfo/celebration.svg": 66883,
	"./carouselInfo/celebration.webp": 96628,
	"./carouselInfo/group.svg": 6730,
	"./carouselInfo/group.webp": 52987,
	"./carouselInfo/minimum.svg": 58643,
	"./carouselInfo/minimum.webp": 80556,
	"./chains/chainspage_cover.png": 66796,
	"./chat.svg": 87186,
	"./chat_filled.svg": 70329,
	"./chat_outline.svg": 28957,
	"./checkCircleFilled.svg": 73132,
	"./cities/CityPageImage.jpg": 74411,
	"./cities/batYam.jpg": 3714,
	"./cities/bneiBrak.jpg": 99876,
	"./cities/givatayim.jpg": 49909,
	"./cities/haifa.jpg": 61305,
	"./cities/holon.jpg": 87922,
	"./cities/jerusalem.jpg": 2186,
	"./cities/netanya.jpg": 53650,
	"./cities/petachTikva.jpg": 87948,
	"./cities/ramatGan.jpg": 7457,
	"./cities/rehovot.jpg": 95323,
	"./cities/rishonLezion.jpg": 80294,
	"./cities/telAviv.jpg": 14919,
	"./city-img-batYam.jpg": 23702,
	"./city-img-bnaiBrak.jpg": 91132,
	"./city-img-givataym.jpg": 44990,
	"./city-img-holon.jpg": 29886,
	"./city-img-jerusalem.jpg": 70302,
	"./city-img-natanya.jpg": 52098,
	"./city-img-ramatGan.jpg": 13925,
	"./city-img-rehovot.jpg": 95999,
	"./city-img-telAviv.jpg": 53355,
	"./cityPageCover/Items.jpeg": 90251,
	"./cityPageCover/american.jpg": 70494,
	"./cityPageCover/asianFusion.jpg": 88546,
	"./cityPageCover/bar.jpg": 52737,
	"./cityPageCover/burgers.jpg": 3560,
	"./cityPageCover/chinese.jpg": 27839,
	"./cityPageCover/coffeeHouse.jpg": 33254,
	"./cityPageCover/confectionery.jpg": 30504,
	"./cityPageCover/convenienceStore.jpg": 35488,
	"./cityPageCover/default.jpg": 96125,
	"./cityPageCover/fish.jpg": 67098,
	"./cityPageCover/homeMade.jpg": 37866,
	"./cityPageCover/humus.jpg": 80164,
	"./cityPageCover/indian.jpg": 48405,
	"./cityPageCover/italian.jpg": 11074,
	"./cityPageCover/meatGrill.jpg": 17793,
	"./cityPageCover/mexican.jpg": 61181,
	"./cityPageCover/noCuisine.jpg": 58571,
	"./cityPageCover/pizza.jpg": 33404,
	"./cityPageCover/saladsAndSandwitches.jpg": 85672,
	"./cityPageCover/seafood.jpg": 66359,
	"./cityPageCover/sushi.jpg": 77964,
	"./colored.svg": 63570,
	"./contrastIcon.svg": 23197,
	"./courier-using-app-2-large-je.png": 40587,
	"./courier-using-app-2-large.png": 42909,
	"./delivery.svg": 98440,
	"./dialogs/closeDialogButton.svg": 28330,
	"./discount_flower.svg": 33777,
	"./discounts/discount-header-background.jpg": 59565,
	"./discounts/discount-header-background.webp": 85230,
	"./discounts/justeat-bag.png": 48146,
	"./discounts/tenbis-bag.png": 98959,
	"./empty-state-2.png": 76940,
	"./errorTriangle.png": 78328,
	"./facebook.svg": 53780,
	"./failurePicture.png": 72092,
	"./fold.svg": 33629,
	"./frustratedImg.png": 55217,
	"./goodbye-large.png": 98989,
	"./gov-orange-lg-logo-old.svg": 94141,
	"./gov-orange-lg-logo.svg": 67017,
	"./green_smiley.png": 37753,
	"./hamburger.svg": 45733,
	"./header-background.png": 52546,
	"./header/basic-close.svg": 47859,
	"./header/x.svg": 32798,
	"./header_triangle_button.svg": 9465,
	"./homepage/advantage-badge.svg": 17476,
	"./homepage/advantages-benefits.svg": 27566,
	"./homepage/advantages-callcenter.png": 5077,
	"./homepage/advantages-control.png": 58875,
	"./homepage/advantages-delivery.png": 91286,
	"./homepage/advantages-delivery.svg": 69570,
	"./homepage/advantages-discount.png": 36763,
	"./homepage/advantages-navigate.svg": 56431,
	"./homepage/advantages-paypo-back.png": 48569,
	"./homepage/advantages-paypo.png": 31761,
	"./homepage/advantages-portals.png": 88645,
	"./homepage/advantages-quotation.png": 58254,
	"./homepage/advantages-system.png": 43673,
	"./homepage/advantages-time.svg": 52621,
	"./homepage/advantages-wallet.svg": 1653,
	"./homepage/app_promo.png": 65172,
	"./homepage/app_promo.webp": 28521,
	"./homepage/app_promo_en.png": 98156,
	"./homepage/app_promo_en.webp": 32129,
	"./homepage/background-burger.jpg": 72239,
	"./homepage/background-burger.webp": 26428,
	"./homepage/background-restaurant_owners.jpg": 80190,
	"./homepage/benefits-bill.png": 70031,
	"./homepage/benefits-card.svg": 54406,
	"./homepage/benefits-commission.png": 491,
	"./homepage/benefits-email.svg": 21612,
	"./homepage/benefits-registration.png": 3499,
	"./homepage/benefits-sales.png": 83942,
	"./homepage/benefits-shopping-cart.svg": 3675,
	"./homepage/benefits-signup.svg": 35024,
	"./homepage/bg-main-desktop.png": 31303,
	"./homepage/bg-main-mobile.png": 31953,
	"./homepage/companies-amdocs.png": 52384,
	"./homepage/companies-ebay.png": 91836,
	"./homepage/companies-keshet.png": 47717,
	"./homepage/companies-mobileye.png": 14403,
	"./homepage/credit-cards/a_tenbis.svg": 38096,
	"./homepage/credit-cards/b_diners-club.svg": 87956,
	"./homepage/credit-cards/c_american-express.svg": 12438,
	"./homepage/credit-cards/d_visa.svg": 7097,
	"./homepage/credit-cards/e_mastercard.svg": 3613,
	"./homepage/facebook-login.png": 11285,
	"./homepage/geo.png": 59294,
	"./homepage/get-on-google-play.png": 25356,
	"./homepage/hamburger-big.png": 14565,
	"./homepage/hamburger-medium.png": 16530,
	"./homepage/hamburger-small.png": 37594,
	"./homepage/hamburger.png": 93720,
	"./homepage/hamburger.svg": 1716,
	"./homepage/ice-cream-big.png": 57060,
	"./homepage/ice-cream-small.png": 43067,
	"./homepage/just-eat/aside-from1004to1281.png": 1982,
	"./homepage/just-eat/aside-from1004to1281.webp": 41415,
	"./homepage/just-eat/aside-from1281.png": 25342,
	"./homepage/just-eat/aside-from1281.webp": 98887,
	"./homepage/just-eat/aside-from570to1004.png": 37152,
	"./homepage/just-eat/aside-from570to1004.webp": 89549,
	"./homepage/just-eat/aside-to570.png": 37653,
	"./homepage/just-eat/aside-to570.webp": 61382,
	"./homepage/landing_page_imgSM.png": 32816,
	"./homepage/logo-transparent.png": 41849,
	"./homepage/main-logo.svg": 66116,
	"./homepage/map.svg": 76415,
	"./homepage/pride-logo.svg": 6881,
	"./homepage/quote-ebay.png": 41095,
	"./homepage/quote-gigya.png": 48815,
	"./homepage/reasons-app.png": 41040,
	"./homepage/reasons-customers.png": 10946,
	"./homepage/reasons-marketing.png": 15753,
	"./homepage/reasons-menu.png": 98988,
	"./homepage/sushi-big.png": 81490,
	"./homepage/sushi-big.webp": 13443,
	"./homepage/sushi-medium.png": 31255,
	"./homepage/sushi-medium.webp": 91220,
	"./homepage/sushi-small.png": 25725,
	"./homepage/sushi-small.webp": 8750,
	"./homepage/ten-bis-card-background.jpg": 72977,
	"./homepage/ten-bis-card-background.webp": 56210,
	"./homepage/tenBis-gov-logo.svg": 69763,
	"./homepage/tenBis-logo-old.svg": 1242,
	"./homepage/user-login.png": 38792,
	"./ic_autorenew.png": 7389,
	"./icons/10bis.svg": 42896,
	"./icons/10bisPlusIcon.svg": 76523,
	"./icons/BackBT.svg": 36830,
	"./icons/DeliveryFeeGift.svg": 71809,
	"./icons/HomeMarker-old.svg": 44682,
	"./icons/NoImgMobileMenu.svg": 26514,
	"./icons/RestaurantMarker-old.svg": 82038,
	"./icons/active.svg": 67439,
	"./icons/address.svg": 34547,
	"./icons/alert-triangle.svg": 60066,
	"./icons/alertCircle.svg": 20597,
	"./icons/appStore.svg": 46333,
	"./icons/arrow.svg": 71952,
	"./icons/arrow_down.svg": 48967,
	"./icons/arrow_down_white.svg": 20945,
	"./icons/arrow_left.svg": 50552,
	"./icons/arrow_left_carousel.svg": 28273,
	"./icons/asian.svg": 39271,
	"./icons/asian_active.svg": 91923,
	"./icons/asian_disabled.svg": 37610,
	"./icons/asian_mobile.svg": 35752,
	"./icons/avatar.svg": 59390,
	"./icons/bell.svg": 86438,
	"./icons/bicycle_active.svg": 32349,
	"./icons/big_green_check.svg": 32216,
	"./icons/burger-menu.svg": 50538,
	"./icons/cards/amex.svg": 81896,
	"./icons/cards/cardsList.png": 94972,
	"./icons/cards/cash.png": 29924,
	"./icons/cards/coloredamex.svg": 36376,
	"./icons/cards/creditCardIcon.png": 73143,
	"./icons/cards/creditcard.png": 86904,
	"./icons/cards/creditcard.svg": 86716,
	"./icons/cards/default.png": 79582,
	"./icons/cards/default.svg": 5720,
	"./icons/cards/defaultBlue.svg": 37764,
	"./icons/cards/defaultGray.png": 86143,
	"./icons/cards/defaultGray.svg": 70965,
	"./icons/cards/defaultWhite.svg": 75375,
	"./icons/cards/diners-club.svg": 75855,
	"./icons/cards/diners.png": 33126,
	"./icons/cards/discover.png": 43972,
	"./icons/cards/discover.svg": 70556,
	"./icons/cards/maestro.png": 65358,
	"./icons/cards/maestro.svg": 63936,
	"./icons/cards/mastercard.png": 89241,
	"./icons/cards/mastercard.svg": 12733,
	"./icons/cards/moneycard.png": 29779,
	"./icons/cards/moneycard.svg": 67965,
	"./icons/cards/newCreditCard.png": 73954,
	"./icons/cards/visa.png": 61230,
	"./icons/cards/visa_icon.svg": 97066,
	"./icons/cart.svg": 59703,
	"./icons/categories_button.svg": 37708,
	"./icons/category_type.svg": 39304,
	"./icons/check_circle.svg": 48922,
	"./icons/checked-icon.svg": 23238,
	"./icons/checked.svg": 244,
	"./icons/checkmark-blue.svg": 73609,
	"./icons/checkmark_green.svg": 13644,
	"./icons/checkmark_outline.svg": 80263,
	"./icons/checkout.svg": 73301,
	"./icons/chevron-down-bold.svg": 33261,
	"./icons/chevron-down.svg": 43051,
	"./icons/chevron-right-small.svg": 43777,
	"./icons/chevron-right.svg": 87731,
	"./icons/chevronLeft.svg": 9745,
	"./icons/circle-info.svg": 90734,
	"./icons/clear_search.svg": 48663,
	"./icons/clear_search_old.svg": 71409,
	"./icons/clear_text.svg": 69998,
	"./icons/clock_alert.svg": 92410,
	"./icons/close-black.svg": 45669,
	"./icons/close-blue.svg": 14248,
	"./icons/close-circle-filled-2.svg": 27764,
	"./icons/close-circle-filled.svg": 74450,
	"./icons/close-darkBlue.svg": 52692,
	"./icons/close-icon-white-background.svg": 83388,
	"./icons/close-popup.svg": 2730,
	"./icons/close-red.svg": 27857,
	"./icons/close-white.svg": 12619,
	"./icons/closeCircle.svg": 27583,
	"./icons/closeMark.svg": 80148,
	"./icons/closeMobileModal.svg": 78516,
	"./icons/coins.svg": 91109,
	"./icons/confetti.svg": 53841,
	"./icons/coupon-blue.svg": 36544,
	"./icons/coupon-orange.svg": 41186,
	"./icons/cross.svg": 51651,
	"./icons/cuisine_type.svg": 8112,
	"./icons/cupon.svg": 5440,
	"./icons/currentLocation.svg": 93073,
	"./icons/cutlery.svg": 12485,
	"./icons/date.svg": 59261,
	"./icons/delete_icon.svg": 71328,
	"./icons/delivery.svg": 47601,
	"./icons/desktopSuccess.svg": 84460,
	"./icons/disabled.svg": 60169,
	"./icons/discount-coupon.svg": 81003,
	"./icons/discount.svg": 31084,
	"./icons/discount_active.svg": 40393,
	"./icons/discount_black.svg": 3800,
	"./icons/discount_disabled.svg": 78403,
	"./icons/discount_mobile.svg": 11065,
	"./icons/discount_orange.svg": 59629,
	"./icons/dish_type.svg": 31656,
	"./icons/drop_down_arrow.svg": 14975,
	"./icons/edit_blue.png": 4294,
	"./icons/edit_blue.svg": 52244,
	"./icons/error.svg": 16577,
	"./icons/facebook-blue.svg": 96338,
	"./icons/facebook-footer.svg": 78931,
	"./icons/facebook.svg": 66501,
	"./icons/failure-icon.svg": 82877,
	"./icons/failure.svg": 16569,
	"./icons/filter-discounts.svg": 2800,
	"./icons/filter-free-delivery-je.svg": 88863,
	"./icons/filter-free-delivery.svg": 41331,
	"./icons/filter-kosher.svg": 64438,
	"./icons/filter-new.svg": 28562,
	"./icons/filter-scoober-delivery.svg": 36488,
	"./icons/filter.svg": 61279,
	"./icons/filter_bicycle.svg": 30341,
	"./icons/filtered.svg": 40908,
	"./icons/filters.svg": 59518,
	"./icons/filters_new_large.svg": 75621,
	"./icons/gluten_free.svg": 67411,
	"./icons/gray-pooledUser.svg": 8357,
	"./icons/green_check.svg": 25835,
	"./icons/green_check_line.svg": 10440,
	"./icons/green_check_mark.svg": 48481,
	"./icons/grey_check_mark.svg": 42023,
	"./icons/groceries-default-image.svg": 82646,
	"./icons/hamburger.svg": 98774,
	"./icons/hamburger_active.svg": 89627,
	"./icons/hamburger_disabled.svg": 62877,
	"./icons/hamburger_mobile.svg": 13803,
	"./icons/home-address.svg": 69575,
	"./icons/homepage-arrow.svg": 22533,
	"./icons/ic_cart.svg": 10906,
	"./icons/ic_cart_minus.svg": 35923,
	"./icons/ic_cart_plus.svg": 63701,
	"./icons/ic_cart_x.svg": 89259,
	"./icons/ic_heart.svg": 80716,
	"./icons/ic_phone.svg": 17420,
	"./icons/info-circle-white.svg": 12758,
	"./icons/infoIcon.svg": 45610,
	"./icons/instagram-footer.svg": 31993,
	"./icons/instagram.svg": 33263,
	"./icons/just-eat.svg": 52190,
	"./icons/kosher-en.svg": 38933,
	"./icons/kosher.svg": 65979,
	"./icons/location-icon.svg": 70590,
	"./icons/location.svg": 26172,
	"./icons/logo.svg": 300,
	"./icons/logo_sq_colored.svg": 45360,
	"./icons/logo_sq_white.svg": 76849,
	"./icons/map.svg": 47241,
	"./icons/menu-dish-image-loading.svg": 28314,
	"./icons/menu-info-icon.svg": 93625,
	"./icons/menu-search.svg": 69993,
	"./icons/message.svg": 39646,
	"./icons/minusSignBig.svg": 20890,
	"./icons/minus_grey.svg": 60415,
	"./icons/mobile_back_blue.svg": 57106,
	"./icons/mobile_back_white.svg": 14521,
	"./icons/mobile_settings.svg": 54081,
	"./icons/new.svg": 265,
	"./icons/pencil-blue.svg": 16663,
	"./icons/pencil-white.svg": 26066,
	"./icons/pie/chevronRight.svg": 55837,
	"./icons/pie/functionalityCloseSmall.svg": 4320,
	"./icons/pie/functionalityLogOut.svg": 9535,
	"./icons/pie/functionalityPlusSmall.svg": 99666,
	"./icons/pie/functionalityTrashSmall.svg": 33850,
	"./icons/pie_israel.svg": 97828,
	"./icons/pie_us.svg": 26156,
	"./icons/pin_restaurant.svg": 44344,
	"./icons/pizza.svg": 37325,
	"./icons/pizza_active.svg": 71814,
	"./icons/pizza_disabled.svg": 41640,
	"./icons/pizza_mobile.svg": 49622,
	"./icons/playStore.svg": 88038,
	"./icons/plus_add_button.svg": 4016,
	"./icons/plus_grey.svg": 1161,
	"./icons/pluseSignBig.svg": 87681,
	"./icons/profileIcon.svg": 62367,
	"./icons/radio_check.svg": 37551,
	"./icons/red_check_line.svg": 41048,
	"./icons/reorder-arrow-down.svg": 15315,
	"./icons/restaurant_tag.svg": 35093,
	"./icons/restaurant_type.svg": 95347,
	"./icons/scoober_tag.svg": 16685,
	"./icons/screen.svg": 82485,
	"./icons/search.svg": 64225,
	"./icons/search_empty_space.png": 90200,
	"./icons/simple-arrow-right.svg": 73134,
	"./icons/spinner.svg": 26200,
	"./icons/star_popular_yellow.svg": 1938,
	"./icons/stores.svg": 69599,
	"./icons/success.svg": 62594,
	"./icons/sushi.svg": 79309,
	"./icons/sushi_active.svg": 25478,
	"./icons/sushi_disabled.svg": 48443,
	"./icons/sushi_mobile.svg": 85750,
	"./icons/ta-icon.svg": 66854,
	"./icons/table_report_menu_icon.svg": 44406,
	"./icons/tapAndSaveIcon.svg": 64971,
	"./icons/target.svg": 9594,
	"./icons/targetIcon.svg": 98073,
	"./icons/tenbisCard.svg": 85138,
	"./icons/tenbisCredit.svg": 4103,
	"./icons/tenbis_square.svg": 24706,
	"./icons/three-dots.svg": 46736,
	"./icons/time-error.svg": 77715,
	"./icons/tooltip_info.svg": 55369,
	"./icons/user_plus.svg": 75023,
	"./icons/vegan.svg": 51256,
	"./icons/voucher-canceled-icon.svg": 48783,
	"./icons/warningIcon.png": 23250,
	"./icons/white-left-arrow-hp.svg": 46547,
	"./icons/white-pooledUser.svg": 97393,
	"./icons/white_cart.svg": 53025,
	"./icons/white_edit.svg": 65471,
	"./je-orange-lg-logo.svg": 14304,
	"./je-orange-sm-logo.svg": 82945,
	"./je_no_result_img.png": 40717,
	"./je_no_result_img.webp": 24414,
	"./je_no_result_img_mobile.png": 91480,
	"./je_no_result_img_mobile.webp": 54181,
	"./just-eat-mobile-logo.svg": 19218,
	"./logo.png": 13653,
	"./menu-empty-search.svg": 82510,
	"./menu.png": 42661,
	"./missingItems.png": 21672,
	"./no-reorders.svg": 20150,
	"./orange-lg-logo.svg": 12060,
	"./orange-sm-logo.svg": 18741,
	"./out-for-delivery-large.png": 59349,
	"./outlineIcon.svg": 13473,
	"./paypal.svg": 86437,
	"./pci-logo.png": 17928,
	"./pickup.svg": 76700,
	"./powered_by_google_on_white.png": 88932,
	"./pride-logo.svg": 21030,
	"./refreshTokenLogout-je.png": 15938,
	"./refreshTokenLogout.png": 55798,
	"./reviewModalImg.png": 25192,
	"./scoober-logo-desktop-en.svg": 90362,
	"./scoober-logo-desktop-he.svg": 70558,
	"./scoober-logo-en.svg": 78143,
	"./scoober-logo-he.svg": 49447,
	"./scoober-logo-icon.svg": 68961,
	"./scrollTop.png": 34870,
	"./scrollTopOld.png": 99267,
	"./search.svg": 47772,
	"./searchNotFound.backup.png": 17149,
	"./settings.svg": 55687,
	"./shopping_cart_page_empty_state.svg": 72269,
	"./sms.jpg": 79061,
	"./star-half.svg": 40918,
	"./star-off.svg": 53764,
	"./star-on.svg": 41614,
	"./star-orange.svg": 3319,
	"./svgIconsAsText/back-arrow-new.svg": 55328,
	"./svgIconsAsText/back-arrow.svg": 49261,
	"./svgIconsAsText/basic-arrow-down.svg": 98335,
	"./svgIconsAsText/clear_search.svg": 40258,
	"./svgIconsAsText/filter.svg": 98654,
	"./svgIconsAsText/filters.svg": 48801,
	"./svgIconsAsText/homepage-arrow.svg": 21640,
	"./svgIconsAsText/mobile_back.svg": 5736,
	"./svgIconsAsText/search-icon-mobile.svg": 34093,
	"./svgIconsAsText/search-icon.svg": 30606,
	"./svgIconsAsText/simple-arrow-right.svg": 31251,
	"./svgIconsAsText/three-dots.svg": 74009,
	"./svgIconsAsText/triangle.svg": 46212,
	"./tag.svg": 49376,
	"./tenBis-logo-md.svg": 9115,
	"./tenBis-logo.svg": 20271,
	"./tosit.svg": 68289,
	"./white-gov-logo.svg": 38960,
	"./white-logo.svg": 4901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93153;